import { createContext } from 'react';
import { IModifiersByCustomerV2, IModifiersByRestaurantV2, IItemForGetShortInfo } from 'types';

export type TSortBy = '' | 'ModifiersA-Z' | 'ModifiersZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'assignRestaurants'
	| 'errorUpdatingModifier'
	| 'editNestedModGroupTemplate'
	| 'errorModifierHasPortions';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedModifierGroup: Nullable<string>;
	isDisabled: Nullable<boolean>;
	isRestricted: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface IModifiersState {
	needRefetchData: boolean;
	modifiersByCustomer: IModifiersByCustomerV2;
	modifiersByRestaurant: IModifiersByRestaurantV2;
	searchString: string;
	rememberMyChoice: boolean;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedModifierGroup: Nullable<string>;
	isDisabled: Nullable<boolean>;
	isRestricted: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForAssignRestaurants: string;
	IDForEditModGroupTemplate: string;
	isInitializedSelectCustomerModal: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const modifiersInitialState: IModifiersState = {
	needRefetchData: false,
	modifiersByCustomer: { totalCount: 0, items: [] },
	modifiersByRestaurant: { totalCount: 0, items: [] },
	searchString: '',
	rememberMyChoice: true,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedModifierGroup: null,
	isDisabled: null,
	isRestricted: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForAssignRestaurants: '',
	IDForEditModGroupTemplate: '',
	isInitializedSelectCustomerModal: false,
	typeOfModalWindow: null,
};

export interface IModifiersContext extends IModifiersState {
	refetchData(value: boolean): void;
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	toggleRememberMyChoice(): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDModifierGroup(value: Nullable<string>): void;
	toggleIsDisabled(): void;
	toggleIsRestricted(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForAssignRestaurants(value: string): void;
	setIDForEditModGroupTemplate(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const ModifiersContext = createContext<IModifiersContext>({
	refetchData: () => undefined,
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	toggleRememberMyChoice: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDModifierGroup: () => undefined,
	toggleIsDisabled: () => undefined,
	toggleIsRestricted: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForAssignRestaurants: () => undefined,
	setIDForEditModGroupTemplate: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...modifiersInitialState,
});
